import { GlobalRequest } from '~/components/global-request'
import { GetServerSideProps, NextPage } from 'next'
import { serverSideCatch } from '~/utils'
import { Layout } from '~/layouts/none'

import { SEOHead } from '~/components/business/SEOHead'
import MirrorHeader from '~/components/pages/mirror/MirrorHeader'
import Banner from '~/components/pages/mirror/Banner'
import Application from '~/components/pages/mirror/Application'
import MirrorFooter from '~/components/pages/mirror/MirrorFooter'
import Solutions from '~/components/pages/mirror/Solutions'
import Partnerships from '~/components/pages/mirror/Partnerships'
import ModelResult from '~/components/pages/mirror/ModelResult'
import { GET_MIRROR_TEMPLATE_LIST } from '~/graphqls/gqls'
import {
  getMirrorTemplateList,
  getMirrorTemplateList_mirrorMarketQuery_homeResourcePackage_categoryList,
} from '~/graphqls/types'
import { useEffect } from 'react'

const UserDetail: NextPage<{
  categoryList: getMirrorTemplateList_mirrorMarketQuery_homeResourcePackage_categoryList[]
}> = ({ categoryList = [] }) => {
  useEffect(() => {
    // 改变滚动条颜色
    document.documentElement.className = 'scrollbar-hidden'
    setTimeout(() => {
      document.documentElement.className = 'scrollbar-mirror'
    })
    return () => {
      document.documentElement.className = ''
    }
  }, [])
  return (
    <Layout
      className="bg-neutral-900 text-neutral-100"
      style={{ minHeight: '100vh' }}
    >
      <SEOHead title={'无界魔镜'} />
      <MirrorHeader />
      <Banner />
      <ModelResult categoryList={categoryList} />
      <Application />
      <Solutions />
      <Partnerships />
      <MirrorFooter />
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  return await serverSideCatch(async () => {
    const { initialState, client } = await GlobalRequest(context)
    try {
      const res = await client.query<getMirrorTemplateList>({
        query: GET_MIRROR_TEMPLATE_LIST,
        variables: {
          offset: 0,
        },
        fetchPolicy: 'no-cache',
      })
      return {
        props: {
          initialState,
          categoryList:
            res.data.mirrorMarketQuery?.homeResourcePackage?.categoryList || [],
        },
      }
    } catch {
      return {
        props: {
          initialState,
        },
      }
    }
  })
}

export default UserDetail
